import React, { Component } from 'react';

import AdUnit from './AdUnit';
import CreateItem from '../../../Common/Partials/CreateItem';
import FetchData from '../../../Framework/Fetch';

type Props = {
  dispatch: any,
  fields: any,
  meta: any,
  record: any,
  syncErrors: any
};

type StateProps = {
  adSizes: string[],
  lookupProperties: string[]
};

class AdUnits extends Component<Props, StateProps> {
  state = { lookupProperties: [], adSizes: [] };

  constructor(props) {
    super(props);

    let adSizes;
    let lookupProperties;

    FetchData('/helpers/ad_sizes', { field: 'name', order: 'ASC' })
      .then(adSizeResponse => {
        adSizes = adSizeResponse as string[];
      });

    const visibility = this.props.record && this.props.record.bordeaux ? 'bordeaux_ad_units' : 'ramp_ad_units';

    FetchData('/helpers/lookup_properties', { field: 'name', order: 'ASC', visibility: visibility })
      .then(lookupPropertyResponse => {
        lookupProperties = lookupPropertyResponse as string[];
      });

    this.state = { adSizes: adSizes, lookupProperties: lookupProperties };
  }

  componentDidMount() {
    FetchData('/helpers/ad_sizes', { field: 'name', order: 'ASC' })
      .then(adSizes => {
        this.setState({ adSizes: adSizes });
      });

    const visibility = this.props.record && this.props.record.bordeaux ? 'bordeaux_ad_units' : 'ramp_ad_units';

    FetchData('/helpers/lookup_properties', { field: 'name', order: 'ASC', visibility: visibility })
      .then(lookupProperties => {
        this.setState({ lookupProperties: lookupProperties });
      });
  }

  handleRemove = (e, index) => {
    this.props.fields.remove(index);
    this.props.record.ad_units.splice(index, 1);
  }

  render() {
    return (
      <div>
        {this.props.fields.length > 0 && this.props.fields.map((item, index) => {
          return (
            <div key={index}>
              <AdUnit
                adSizes={this.state.adSizes}
                dispatch={this.props.dispatch}
                fields={this.props.fields}
                handleRemove={this.handleRemove}
                index={index}
                item={item}
                lookupProperties={this.state.lookupProperties}
                record={this.props.record}
                submitFailed={this.props.meta.submitFailed}
                syncErrors={this.props.syncErrors} />
              <br />
              <br />
            </div>
          )
        })}
        <div style={{ paddingTop: 20 }}>
          <CreateItem fields={this.props.fields} label="Add Ad Unit" />
        </div>
      </div>
    )
  }
};

export default AdUnits;



// WEBPACK FOOTER //
// ./src/views/Components/Placements/Partials/AdUnits.tsx